import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getProfileId = async (name: string) => {
  const { data, error } = await supabase
    .from('user_profiles')
    .select('username')
    .eq('id', name)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data.username
}

export default function useGetUsernameById(name: string | undefined) {
  return useQuery({
    queryKey: ['useGetUsernameById', name],
    queryFn: () => getProfileId(name || ''),
    staleTime: 0,
    enabled: !!name,
  })
}
